import { Dialog as Mui4Dialog, DialogProps as Mui4DialogProps } from '@material-ui/core'
import { default as Mui5Dialog, DialogProps as Mui5DialogProps } from '@mui/material/Dialog'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'

export enum OsDialogVersion {
  V1 = 1, // MUI4
  V2 = 2, // MUI5 + Stratis UI
}
export type DialogProps = Mui4DialogProps & {
  sx?: Mui5DialogProps['sx']
}
/** @deprecated Use DialogProps */
export type OsDialogProps = DialogProps

export const Dialog = forwardRef<HTMLDivElement, DialogProps>((props, ref) => {
  const version = useComponentVersion('dialog')
  switch (version) {
    case OsDialogVersion.V2:
      //@ts-ignore TODO: fix this ref typing issue
      return <Mui5Dialog ref={ref} {...props} />

    default:
      return <Mui4Dialog ref={ref} {...props} />
  }
})
